// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"07dafcd0","622":"d74574c9","787":"05fc50ad"}[chunkId] + ".chunk.js";
};